import initAxios from "./initAxios";

class ChatApi {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
    this.axios = initAxios({ baseURL: apiUrl, withCredentials: true });
  }

  getUnreadCount = () => this.axios.get("/api/channels/unread");

  /**
   *  метод обновляет присутствие пользователя на сайте,
   *  нужен для чата и должен запускаться каждые 15-16 минут
   */
  updatePresence = () => this.axios.get("/presence/update");
}

export default ChatApi;
